// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-mobile{
    position: fixed;
        top: 30px;
        left: 0;
        width: 100vw;
        height: 130px;
        background-color: #e42727;
        align-items: center;
        z-index: 5;
        opacity: 1;
}
.mobile-navbar-links{
    display:flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top:10px;
}
.mobile-menu-icon{
    margin-left: 40px;
}

.mobile-nav-icons{
    margin-right: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    
}

.mobile-nav-icons span{
    background-color: #F2C713;
        padding: 2px 5px;
        width: 30px;
        height: 20px;
        border-radius: 50%;
        font-size: xx-small;
        border-style: solid;
        border-color: red;
        border-width: 1px;
        margin-left: -20px;
        
}


.mobile-nav-links{
    display: none;
}

.navbar-mobile .mobile-nav-links.open{
    display: flex;
    flex-direction: column;
    width:90%;
    height:fit-content;
    
    margin:0 auto;
    z-index: 5;
    background-color: #FFF;
    border-radius: 20px;
    margin-top:30px;
    margin-bottom: 0px;
    
            
                
}

.mobile-nav-links.open ul{
    list-style-type: none;
    
    display: flex;
    flex-direction: column;
    color:#444;
    justify-items: left;
    text-align: left;
    text-decoration: none;
    width:100%;
    height:100%;
}

.mobile-nav-user{
    display: none;
}

.mobile-nav-user.open {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: 90%;
    height: fit-content;
    margin-top: 20px;
    align-items: center;
    justify-content: center;
    z-index: 5;
    background-color: #FFF;
    border-radius: 20px;
    padding: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.3);
    padding-bottom: 0px;
    margin-bottom: 0px;
   
}

.mobile-nav-links.open ul li a{
    text-decoration: none;
    color: #444;
    font-family: 'Poppins',sans-serif;
    font-size:16px;
    padding:5px;
    margin-bottom: 10px;
    border-radius: 5px;

}

.mobile-nav-user.open img{
    width:40px;
    height:40px;
    margin: 10px 0px;
}

.mobile-nav-user.open p{
    margin:10px 0px;
    font-size: 16px;
    font-family: 'Poppins',sans-serif;
}

.mobile-nav-user.open a{
    margin: 10px 0px;
    cursor: pointer;
    text-decoration: none;
    color:#e42727;

}



.nav-links-dropdown{
    display: flex;
    flex-direction: row;
}

.nav-links-fontawesome-icon{
  margin-right: 50px;
  margin-left: auto;
 
}
.mobile-nav-links.open ul li a:hover{
    
}

.distributor-dropdown-content{
   display: none;
}

.distributor-dropdown-content.open{
    display: flex;
        flex-direction: column;
        margin:0px auto;
        width: 90%;
        height: 100%;
        z-index: 5;
        background-color: #FFF;
        border-radius: 20px;
}

.distributor-dropdown-content.open ul {
    list-style-type: none;

    display: flex;
    flex-direction: column;
    color: #444;
    justify-items: left;
    text-align: left;
    text-decoration: none;
}

.distributor-dropdown-content.open ul li a {
    text-decoration: none;
    color: #444;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    margin-bottom: 10px;

}`, "",{"version":3,"sources":["webpack://./src/Styles/mobileNavbar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;QACX,SAAS;QACT,OAAO;QACP,YAAY;QACZ,aAAa;QACb,yBAAyB;QACzB,mBAAmB;QACnB,UAAU;QACV,UAAU;AAClB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,yBAAyB;QACrB,gBAAgB;QAChB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;;AAE1B;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;;IAElB,aAAa;IACb,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;;;;AAItB;;AAEA;IACI,qBAAqB;;IAErB,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,iCAAiC;IACjC,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,aAAa;;AAEjB;;;;AAIA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;;AAEnB;AACA;;AAEA;;AAEA;GACG,aAAa;AAChB;;AAEA;IACI,aAAa;QACT,sBAAsB;QACtB,eAAe;QACf,UAAU;QACV,YAAY;QACZ,UAAU;QACV,sBAAsB;QACtB,mBAAmB;AAC3B;;AAEA;IACI,qBAAqB;;IAErB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,mBAAmB;;AAEvB","sourcesContent":[".navbar-mobile{\n    position: fixed;\n        top: 30px;\n        left: 0;\n        width: 100vw;\n        height: 130px;\n        background-color: #e42727;\n        align-items: center;\n        z-index: 5;\n        opacity: 1;\n}\n.mobile-navbar-links{\n    display:flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-top:10px;\n}\n.mobile-menu-icon{\n    margin-left: 40px;\n}\n\n.mobile-nav-icons{\n    margin-right: 40px;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    \n}\n\n.mobile-nav-icons span{\n    background-color: #F2C713;\n        padding: 2px 5px;\n        width: 30px;\n        height: 20px;\n        border-radius: 50%;\n        font-size: xx-small;\n        border-style: solid;\n        border-color: red;\n        border-width: 1px;\n        margin-left: -20px;\n        \n}\n\n\n.mobile-nav-links{\n    display: none;\n}\n\n.navbar-mobile .mobile-nav-links.open{\n    display: flex;\n    flex-direction: column;\n    width:90%;\n    height:fit-content;\n    \n    margin:0 auto;\n    z-index: 5;\n    background-color: #FFF;\n    border-radius: 20px;\n    margin-top:30px;\n    margin-bottom: 0px;\n    \n            \n                \n}\n\n.mobile-nav-links.open ul{\n    list-style-type: none;\n    \n    display: flex;\n    flex-direction: column;\n    color:#444;\n    justify-items: left;\n    text-align: left;\n    text-decoration: none;\n    width:100%;\n    height:100%;\n}\n\n.mobile-nav-user{\n    display: none;\n}\n\n.mobile-nav-user.open {\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto;\n    width: 90%;\n    height: fit-content;\n    margin-top: 20px;\n    align-items: center;\n    justify-content: center;\n    z-index: 5;\n    background-color: #FFF;\n    border-radius: 20px;\n    padding: 10px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.3);\n    padding-bottom: 0px;\n    margin-bottom: 0px;\n   \n}\n\n.mobile-nav-links.open ul li a{\n    text-decoration: none;\n    color: #444;\n    font-family: 'Poppins',sans-serif;\n    font-size:16px;\n    padding:5px;\n    margin-bottom: 10px;\n    border-radius: 5px;\n\n}\n\n.mobile-nav-user.open img{\n    width:40px;\n    height:40px;\n    margin: 10px 0px;\n}\n\n.mobile-nav-user.open p{\n    margin:10px 0px;\n    font-size: 16px;\n    font-family: 'Poppins',sans-serif;\n}\n\n.mobile-nav-user.open a{\n    margin: 10px 0px;\n    cursor: pointer;\n    text-decoration: none;\n    color:#e42727;\n\n}\n\n\n\n.nav-links-dropdown{\n    display: flex;\n    flex-direction: row;\n}\n\n.nav-links-fontawesome-icon{\n  margin-right: 50px;\n  margin-left: auto;\n \n}\n.mobile-nav-links.open ul li a:hover{\n    \n}\n\n.distributor-dropdown-content{\n   display: none;\n}\n\n.distributor-dropdown-content.open{\n    display: flex;\n        flex-direction: column;\n        margin:0px auto;\n        width: 90%;\n        height: 100%;\n        z-index: 5;\n        background-color: #FFF;\n        border-radius: 20px;\n}\n\n.distributor-dropdown-content.open ul {\n    list-style-type: none;\n\n    display: flex;\n    flex-direction: column;\n    color: #444;\n    justify-items: left;\n    text-align: left;\n    text-decoration: none;\n}\n\n.distributor-dropdown-content.open ul li a {\n    text-decoration: none;\n    color: #444;\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n    margin-bottom: 10px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
